$shm_hitalama_components_menu $mol_page
	definition $shm_hitalama_map_widget_entity_custom
	versions $shm_hitalama_components_versions
	drafts $shm_hitalama_components_drafts_model
	tab \preview
	minimal_width 224
	title_content / <= Name $mol_view
		sub / <= title
	tools /
		<= Close $mol_link
			hint \Закрыть приложение
			arg *
				component null
				application_tab null
				application_version null
				application_run null
				application_draft null
				application_draft_edit null
			sub / <= Close_icon $mol_icon_close
	body /
		<= Version $mol_text
			text <= version_label \
		<= Links $mol_list
			rows <= links /
	Link* $mol_link
		arg <= link_arg* *
		current <= link_current* false
		sub <= link_content* /$mol_view_content
	Drafts_count $mol_view
		sub / <= drafts_count \
